<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit.prevent="register" method="POST">
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <!-- <CInput
                  placeholder="Username"
                  autocomplete="username"
                  v-model="name"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput> -->
                <!-- <CInput
                  placeholder="Email"
                  prepend="@"
                  autocomplete="email"
                  v-model="email"
                /> -->
                <CInput
                  placeholder="Password"
                  type="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  autocomplete="new-password"
                  :value.sync="$v.password.$model"
                  :isValid="checkIfValid('password')"
                  invalidFeedback="This is a required field"
                  v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  placeholder="Repeat password"
                  type="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  autocomplete="new-password"
                  :value.sync="$v.password_confirmation.$model"
                  :isValid="checkIfValid('password_confirmation')"
                  invalidFeedback="This must match password"
                  class="mb-4"
                  v-model="password_confirmation"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CButton type="submit" :disabled="!isValid" color="success" block>Complete Registration</CButton>
                <small-loader v-if="loading"></small-loader>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, email, sameAs, helpers } from "vuelidate/lib/validators"
var methods = {}

methods.checkIfValid = function (fieldName) {
  const field = this.$v[fieldName]
  if (!field.$dirty) {
    return null
  } 
  return !(field.$invalid || field.$model === '')
}

methods.register = function () {
  this.loading = true
  var self = this;
  axios.post( this.$apiAdress + '/api/confirmRegistration', {
    password: self.password,
    password_confirmation: self.password_confirmation,
    token: self.token
  }).then(function (response) {
    self.name = '';
    self.email = '';
    self.password = '';
    self.password_confirmation = '';
    console.log(response);
    self.$router.push({ path: '/login' });
  })
  .catch(function (error) {
    console.log(error);
  });

}

export default {
  data() {
    return {
      password: '',
      password_confirmation: '',
      loading: false
    }
  },
  props: ['token'],
  mixins: [validationMixin],
  validations: {
    password: {
      required
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  computed: {
    isValid () { return !this.$v.$invalid },
    isDirty () { return this.$v.$anyDirty },
  },
  methods: methods
}

</script>
